import { render, staticRenderFns } from "./send_receipt_button.vue?vue&type=template&id=4f9af856&scoped=true&"
import script from "./send_receipt_button.vue?vue&type=script&lang=js&"
export * from "./send_receipt_button.vue?vue&type=script&lang=js&"
import style0 from "./send_receipt_button.vue?vue&type=style&index=0&id=4f9af856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9af856",
  null
  
)

export default component.exports